<script>
import env from '@root/env';
import BOGen from '@helper/BOGen';
import Gen from '@helper/Gen';

export default {
  computed:{
		user(){ return this.$root.user },
		fields(){ return this.$root.fields },
		web(){ return this.$root.web },
		app(){ return this.$root.app },
    page(){ return this.$root.page },
    loadingOverlay:{
      get(){ return this.$root.var.loadingOverlay },
      set(v){ return this.$root.var.loadingOverlay = v },
    },
    isMobile(){
      return this.$root.width < 768
    }
  },
  methods:{
    assets(type, filename) {
      const path = {
        bo_images: 'assets/images',
      }
      return env.baseUrl + "/" + (path[type]||type) + (filename ? "/" + filename : "" );
    },
    uploader(filename, size) {
      var sizePath = size ? "/img/"+size+"/" : "/uploader/";
      return env.baseUrl + sizePath + (filename ? filename : "");
    },
    refreshVariable(){
      var variable = Gen.getStorage("variable", {});
      Object.keys(variable).forEach((k)=>{
        this.$root[k] = variable[k]
      })
      BOGen.apirest("/variable", {}, (err, resp)=>{
        if(err) return;
        Gen.putStorage("variable", resp)
        Object.keys(resp).forEach((k)=>{
          this.$root[k] = resp[k]
        })
      })
    },
    refreshVariableFo(){
      var variable = Gen.getStorage("variable", {});
      Object.keys(variable).forEach((k)=>{
        this.$root[k] = variable[k]
      })
      Gen.apirest("/variable", {}, (err, resp)=>{
        if(err) return;
        Gen.putStorage("variable", resp)
        Object.keys(resp).forEach((k)=>{
          this.$root[k] = resp[k]
        })
        global.variableLoaded = true
      })
    },
    readyVariable(callback){
      var iN = setInterval(()=>{
        if(global.variableLoaded){
          clearInterval(iN)
          callback()
        }
      }, 50)
    },
    LoadingOverlay(params = {}){
      return this.$loading.show(params);
    }
  }
}
</script>
